import { render } from "./WebMenu.vue?vue&type=template&id=cdb4b4ea"
import script from "./WebMenu.vue?vue&type=script&lang=js"
export * from "./WebMenu.vue?vue&type=script&lang=js"

import "./WebMenu.vue?vue&type=style&index=0&id=cdb4b4ea&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__